import React from 'react';
import iconTemplate from './IconTemplate';

export default iconTemplate(
    <svg
        width="24"
        height="23"
        viewBox="0 0 24 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M17.2506 21.9464C16.978 20.848 16.3569 19.8647 15.4775 19.1458C14.5398 18.3794 13.366 17.9607 12.1549 17.9607C10.9439 17.9607 9.77005 18.3794 8.83236 19.1458C7.95291 19.8647 7.33191 20.848 7.05933 21.9464"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.1543 17.9609C14.1515 17.9609 15.2749 16.8375 15.2749 14.8404C15.2749 12.8432 14.1515 11.7198 12.1543 11.7198C10.1571 11.7198 9.03369 12.8432 9.03369 14.8404C9.03369 16.8375 10.1571 17.9609 12.1543 17.9609Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M17.3504 7.2948C19.3476 7.2948 20.471 6.17139 20.471 4.17419C20.471 2.17701 19.3476 1.05359 17.3504 1.05359C15.3532 1.05359 14.2297 2.17701 14.2297 4.17419C14.2297 6.17139 15.3532 7.2948 17.3504 7.2948Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M22.4462 11.2803C22.1736 10.1818 21.5526 9.19853 20.6732 8.47971C19.7356 7.71329 18.5617 7.29462 17.3506 7.29462C16.1396 7.29462 14.9658 7.71329 14.0281 8.47971"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.64966 7.2948C4.65246 7.2948 3.52905 6.17139 3.52905 4.17419C3.52905 2.17701 4.65246 1.05359 6.64966 1.05359C8.64684 1.05359 9.77026 2.17701 9.77026 4.17419C9.77026 6.17139 8.64684 7.2948 6.64966 7.2948Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1.55371 11.2803C1.82629 10.1818 2.4473 9.19853 3.32674 8.47971C4.26443 7.71329 5.43824 7.29462 6.6493 7.29462C7.86035 7.29462 9.03417 7.71329 9.97186 8.47971"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>,
) as React.FC;
